import React, { useEffect, useRef, useState } from 'react';
import useQuery from '../../../util/useQuery';
import PreviewArticle from './component/PreviewArticle';

import HRPolicyService from '../../../services/HRPolicy.service';
import GlobalService from '../../../services/Global.service';
import { sendHeightToIframe } from '../sendHeight';

export default function ViewHR() {
    const params = useQuery();
    const id = params.get('id');
    const lang = params.get('lang');
    const [detail, setDetail] = useState(false);
    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = useState('');
    const ref = useRef();

    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(
                companyLogoId
            );
            if (data.resultData?.imageId) {
                setLogo(`data:image/png;base64,${data.resultData?.imageId}`);
            } else {
                setLogo('');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getHRPolicyDetailPublic = async () => {
            try {
                const { data } = await HRPolicyService.getHRPolicyDetailPublic(
                    id
                );
                if (data?.resultData) {
                    const parse = JSON.parse(data?.resultData?.data);
                    setDetail(parse);
                    setLoading(false);
                    setLogo('');
                    if (parse?.hrPrivacyPolicy?.hrCompanyLogoId) {
                        getImage(parse?.hrPrivacyPolicy?.hrCompanyLogoId);
                    }
                    sendHeightToIframe(ref.current);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };
        if (id) getHRPolicyDetailPublic();
        document.body.style.background = 'transparent';
    }, [id]);

    return (
        <div ref={ref}>
            <PreviewArticle
                logo={logo}
                lang={lang}
                detail={detail}
                loading={loading}
                mode="view"
            />
        </div>
    );
}
